import React from 'react';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';
import bgImage from './assets/bg.png';
import bgMobileImage from './assets/bg-mobile.png';
import styles from './style.module.scss';
import Cooperation from './components/Cooperation';
import Join from './components/Join';
import PC from '../Device/PC';
import Mobile from '../Device/Mobile';

const JoinUs = () => {
  const { t } = useTranslation('joinus');
  return (
    <>
      <section className={styles.head}>
        <PC>
          <div className={styles.bg}>
            <Image src={bgImage} alt="加入悟空中文" />
          </div>
        </PC>
        <Mobile>
          <div className={styles.bg}>
            <Image src={bgMobileImage} alt="加入悟空中文" />
          </div>
        </Mobile>
        <div className={styles.titleWrap}>
          <h1 className={styles.mainTitle}>{t('与悟空合作')}</h1>
        </div>
      </section>
      <Cooperation />
      <Join />
    </>
  );
};

export default JoinUs;
